import { useContext } from 'react';
import type { Services } from './types';
import { ServicesContext } from './Context';
import { ServicesProvider } from './Provider';

export const useServices = (): Services => {
  const context = useContext(ServicesContext);
  if (!context) throw new Error(`${useServices.displayName} must be used within a ${ServicesProvider.displayName}`);
  return context;
};

useServices.displayName = 'useServices' as const;

export const useEnmonServices = (): Services['backendGateway'] => {
  const { backendGateway } = useServices();
  return backendGateway;
};
